/* eslint-disable no-unused-vars */
/* eslint-disable no-underscore-dangle */
/* eslint-disable default-param-last */
/* eslint-disable import/no-cycle */
// eslint-disable-next-line import/no-extraneous-dependencies
import { API_URL, CONFIG } from '../config/constant'
import {
  emptyLocalStorage,
  getLocalStorage,
  setLocalStorage,
} from './localStorage'
import { isBo } from './CommonMethods'
import { ACCESS_TOKEN, REFRESH_TOKEN } from './constants'
import { url } from '../services/path-url'

const axios = require('axios')

let isRefreshing = false

const failedRequestQueue = []

const processQueue = (error, token = null) => {
  failedRequestQueue.forEach((prom) => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve(token)
    }
  })
}

const forceLogout = async () => {
  emptyLocalStorage()
  const urlRedirect = isBo() ? '/bo/auth/signin' : '/auth/signin'
  if (window.location.pathname !== urlRedirect) {
    window.location.assign(`${window.location.origin + urlRedirect}`)
  }
}

const abort = (s) => ({
  signal: s,
})

const getAuthorizeHeader = (token, si) => ({
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
    Accept: 'application/json',
  },
  ...abort(si),
})

const axiosProvider = axios.create({
  baseURL: API_URL,
  // withCredentials: true,
  xsrfCookieName: process.env.REACT_APP_ARROW_XSRFCOOKIENAME ?? 'XSRF-TOKEN',
  timeout: CONFIG.axiosTimeOut * 1000 ?? 30000,
})

axiosProvider.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(error)
)

const interceptorResponse = axiosProvider.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config

    const isNot401Error = error?.response?.status !== 401

    if (isNot401Error) {
      return Promise.reject(
        (error.response && error.response.data) || 'Wrong cms Service'
      )
    }

    // ── Case 1: The refresh token request itself returned 401 ──
    if (originalRequest._isRefreshTokenRequest) {
      processQueue(error, null)
      isRefreshing = false
      await forceLogout()
      return Promise.reject(error)
    }

    // ── Case 2: Request already retried once → avoid infinite retry loop ──
    // ──  The new token retrieved after refreshing is still 401 ──
    if (originalRequest._retry) {
      await forceLogout()
      return Promise.reject(error)
    }

    // ── Case 3: A refresh is already in progress ──
    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedRequestQueue.push({ resolve, reject })
      })
        .then((newToken) => {
          originalRequest.headers.Authorization = `Bearer ${newToken}`
          return axiosProvider(originalRequest)
        })
        .catch((err) => Promise.reject(err))
    }

    // ── Case 4: First 401 — trigger a token refresh ──
    originalRequest._retry = true
    isRefreshing = true

    try {
      const params = {
        refreshtoken: getLocalStorage(REFRESH_TOKEN),
      }
      const accesToken = getLocalStorage(ACCESS_TOKEN)
      const refreshResponse = await axiosProvider.post(
        url.auth.refresh,
        params,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accesToken}`,
            Accept: 'application/json',
          },
          _isRefreshTokenRequest: true,
        }
      )
      const { accesstoken, refreshtoken } = refreshResponse.data
      setLocalStorage(ACCESS_TOKEN, accesstoken)
      setLocalStorage(REFRESH_TOKEN, refreshtoken)
      originalRequest.headers.Authorization = `Bearer ${accesstoken}`
      processQueue(null, accesstoken)
      return axiosProvider(originalRequest)
    } catch (refreshError) {
      // ── Refresh request failed (non-401 errors like network issues) ──
      processQueue(refreshError, null)
      await forceLogout()
      return Promise.reject(refreshError)
    } finally {
      isRefreshing = false
    }
  }
)

axios.interceptors.response.eject(interceptorResponse)

/**
 * Get Request With Token
 * * */
const get = (url, token, sig) =>
  axiosProvider.get(url, getAuthorizeHeader(token, sig))

/**
 * Post Request With Token
 * * */
const post = (url, data, token, sig) =>
  axiosProvider.post(url, data, getAuthorizeHeader(token, sig))

/**
 * Put Request With Token
 * * */
const put = (url, data, token, sig) =>
  axiosProvider.put(url, data, getAuthorizeHeader(token, sig))

/**
 * Delete Request With Token
 * * */
const remove = (url, token, sig) =>
  axiosProvider.delete(url, getAuthorizeHeader(token, sig))

/**
 * Post Request
 * * */
const publicPost = (url, data) => axiosProvider.post(url, data)

const axiosServices = {
  get,
  post,
  put,
  remove,
  publicPost,
}

export default axiosServices
